import type React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import type { ReactNode } from 'react';

interface UserPanelProps {
  caseCode: string;
  children?: ReactNode;
}

export const UserPanel: React.FC<UserPanelProps> = observer((props) => {
  return (
    <Container>
      <TextWrapper>
        {props.children}
        <CaseId>{props.caseCode}</CaseId>
      </TextWrapper>
    </Container>
  );
});

const Container = styled.div`
  overflow: hidden;
`;

const TextWrapper = styled.div`
  position: relative;
  text-align: left;
  font-size: 0.8em;
  padding-right: 1em;
  display: flex;
  align-items: center;
`;

const CaseId = styled.h2`
  white-space: nowrap;
  font-size: 1.1em;
  font-weight: normal;
  margin-left: 2em;
  color: ${({ theme }): string => theme.palette.primary.main};
`;
